export const whatIsPetWorld = {
  header: 'What is Kitten City?',
  des: 'Kitten City - TON Virtual NFT Pets of your own! Fanta team presents you with an addicting and amusing Play to Earn game on Aptos (APT). Each KittenCity is a digital version of your real pet that requires a lot of care, and it is your responsibility to provide the finest care possible. Feed, dress up, take care of, and fight with other pets to earn CPM token (Kitten City Money)',
  bg: require('../../images/bg/webp/cat-feet.webp'),
  img: require('../../images/bg/webp/bg-3-pet-avatar.webp'),
  afterImg: require('../../images/ether-diamond.gif'),
}
